import Block from '../../adapters/helpers/Block';
import React, { useEffect, Suspense } from 'react'
import Loader from '../../adapters/helpers/Loader';
import DOMPurify from 'isomorphic-dompurify';

function HTMLBlock(props) {
    const block = new Block(props);
    const id = block.getAnchorId();
    const className = 'ob-html-block ' + block.getFieldValue('classNames');
    const text = block.getFieldValue('text');

    useEffect(() => {
        var allLegalCheckBox = document.querySelectorAll(".legal-checkbox");
        if (allLegalCheckBox.length > 1) {
            allLegalCheckBox[0].addEventListener("click", function () {
                for (let i = 0; i < allLegalCheckBox.length; i++) {
                    if (allLegalCheckBox[i].type == "checkbox")
                        console.log(allLegalCheckBox[i].checked = allLegalCheckBox[0].checked)
                }
            })
        }
     })

    return (
        <Suspense fallback={<Loader />}>
        <div
            id={id}
            className={className}
            dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(text)}}
        >
        </div>
        </Suspense>
    )
}

HTMLBlock.propTypes = {

};

export default HTMLBlock;
